import type { TovVersionResponse } from "contracts/api/client-tov/version.responses";
import { TOV_EXAMPLE_TYPES, TOV_SCOPE_TYPES } from "contracts/enums/tov-voice";
import { For, Show } from "solid-js";
import { TOV_FIELD_KIND } from "../../enums/tov";
import { type CardEditProps, EditableCard, type FieldSpec } from "./EditForms";
import { Group } from "./Group";
import { CardGrid } from "./primitives";

const EXAMPLE_FIELDS: FieldSpec[] = [
  {
    name: "exampleType",
    label: "Type",
    kind: TOV_FIELD_KIND.SELECT,
    options: TOV_EXAMPLE_TYPES,
  },
  {
    name: "scopeType",
    label: "Scope",
    kind: TOV_FIELD_KIND.SELECT,
    options: TOV_SCOPE_TYPES,
  },
  {
    name: "scopeKey",
    label: "Scope key",
    kind: TOV_FIELD_KIND.TEXT,
    optional: true,
  },
  {
    name: "inputText",
    label: "Input",
    kind: TOV_FIELD_KIND.TEXT,
    optional: true,
    grow: true,
  },
  {
    name: "outputText",
    label: "Output",
    kind: TOV_FIELD_KIND.TEXT,
    grow: true,
  },
  {
    name: "explanation",
    label: "Explanation",
    kind: TOV_FIELD_KIND.TEXT,
    grow: true,
  },
];

export function ExampleCards(props: {
  version: TovVersionResponse;
  edit: CardEditProps;
}) {
  return (
    <Group title="Examples" empty={props.version.examples.length === 0}>
      <CardGrid>
        <For each={props.version.examples}>
          {(example) => (
            <EditableCard
              title={example.exampleType}
              editable={props.edit.editable}
              fields={EXAMPLE_FIELDS}
              initial={{
                exampleType: example.exampleType,
                scopeType: example.scopeType,
                scopeKey: example.scopeKey ?? undefined,
                inputText: example.inputText ?? undefined,
                outputText: example.outputText,
                explanation: example.explanation,
                displayOrder: example.displayOrder,
              }}
              onSave={(values) =>
                props.edit.onEdit("examples", example.id, values)
              }
              onDelete={() => props.edit.onDelete("examples", example.id)}
            >
              <Show when={example.inputText}>
                <p class="tov-sub">In: {example.inputText}</p>
              </Show>
              <p class="tov-desc">{example.outputText}</p>
              <p class="tov-sub">{example.explanation}</p>
            </EditableCard>
          )}
        </For>
      </CardGrid>
    </Group>
  );
}
